import { PropTypes } from 'prop-types';
import React from 'react';
import { createPortal } from 'react-dom';
import styled, { withTheme } from 'styled-components';

import { DetailsDismissInert } from '@ge/shared/components/entity-details/dismiss-inert';
import { elevations } from '@ge/tokens/elevations';
import { useDraggablePosition } from '@ge/web-client/src/app/hooks/use-draggable-position';

const ModalWrapper = styled.div`
  background-color: ${(props) => (props.draggable ? 'transparent' : props.theme.modal.overlay)};
  bottom: ${(props) => (props.draggable ? 'auto' : '0')};
  right: ${(props) => (props.draggable ? 'auto' : '0')};
  padding: 12px;
  position: fixed;
  z-index: ${elevations.P100};
  cursor: ${(props) => (props.draggable ? 'grab' : 'default')};
  top: ${(props) => (props.draggable ? `${props.top}px` : '0')};
  left: ${(props) => (props.draggable ? `${props.left}px` : '0')};
`;

const OverlayWrapper = styled.div`
  z-index: 90;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.theme.modal.overlay};
  pointer-events: ${(props) => (props.draggable ? 'auto' : 'none')};
`;

const ModalComponent = ({ isOpen, children, portalId, draggable }) => {
  const { dragRef, handleMouseDown, position } = useDraggablePosition();
  if (!isOpen) {
    return null;
  }

  return createPortal(
    <DetailsDismissInert>
      <>
        {draggable && (
          <OverlayWrapper draggable={draggable}>
            <ModalWrapper
              ref={dragRef}
              onMouseDown={handleMouseDown}
              top={position.top}
              left={position.left}
              draggable={draggable}
            >
              {children}
            </ModalWrapper>
          </OverlayWrapper>
        )}
        {!draggable && (
          <ModalWrapper
            onMouseDown={handleMouseDown}
            top={position.top}
            left={position.left}
            draggable={draggable}
          >
            {children}
          </ModalWrapper>
        )}
      </>
    </DetailsDismissInert>,
    document.querySelector(portalId),
  );
};

ModalComponent.propTypes = {
  isOpen: PropTypes.bool,
  children: PropTypes.node,
  portalId: PropTypes.string,
  draggable: PropTypes.bool,
};

ModalComponent.defaultProps = {
  cancelText: 'cancel',
  confirmText: 'OK',
  isOpen: false,
  children: null,
  onConfirm: () => null,
  portalId: '#portal-root',
  draggable: false,
};

export const Modal = withTheme(ModalComponent);
